export type LandingVariant = 'art' | 'linktree';

export function getLandingVariant(isListenPage: boolean): LandingVariant {
  return isListenPage ? 'linktree' : 'art';
}
